module.exports = __webpack_public_path__ + "img/16.f66f1962.jpg";